import { render, staticRenderFns } from "./SharingYoutubeMetadata.vue?vue&type=template&id=3b45da9e&"
import script from "./SharingYoutubeMetadata.vue?vue&type=script&lang=js&"
export * from "./SharingYoutubeMetadata.vue?vue&type=script&lang=js&"
import style0 from "./SharingYoutubeMetadata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports